export default {
  ui: {},

  
	init() {
		this.bindUI();
    this.bindEvents();
    console.log('careers init');
	},

  bindUI() {
    this.ui.file  = document.querySelector('.js-file');
    this.ui.inputs = this.ui.file.querySelectorAll( '.inputfile' );
	},

	bindEvents() {

    // var inputs = document.querySelectorAll( '.inputfile' );

    Array.prototype.forEach.call( this.ui.inputs, function( input )
    {
      var label	 = input.closest('.file').querySelector('label'),
        labelVal = label.innerHTML;

      input.addEventListener( 'change', function( e )
      {
        var fileName = '';
        if( this.files && this.files.length > 1 )
          fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
        else
          fileName = e.target.value.split( '\\' ).pop();

        if( fileName ) {
          label.querySelector( 'span' ).innerHTML = fileName;
          this.parentNode.parentNode.classList.add('up');
        } else{
          label.innerHTML = labelVal;
          this.parentNode.parentNode.classList.remove('up');
        }
      });

      // Firefox bug fix
      input.addEventListener( 'focus', function(){ input.classList.add( 'has-focus' ); });
      input.addEventListener( 'blur', function(){ input.classList.remove( 'has-focus' ); });
    });

  },

  finalize() {
    // JavaScript to be fired on the careers page, after the init JS
    $('select option:first').attr('disabled', 'disabled');// Disable the first value/label ---
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/careers.js